import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from 'modules';
import { TSubjectLayout, TDetailLayout, TLearningParams } from 'modules/learning';
import { CFINANCE_THEME, CMAIN_THEMES } from 'constants/learningboard.const';
import styled from 'styled-components';
import { device } from 'GlobalStyles';

const ExplainTemplate = ({
  img,
  pageTitle,
  pageSubtitle,
  children,
  hasSubject,
}: TSubjectLayout & TDetailLayout) => {
  const { category, example_id }: TLearningParams = useParams();
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);

  const [{ name }] =
    currentUser?.primary_field !== 'finance'
      ? CMAIN_THEMES.filter(({ link }) => link === category)
      : CFINANCE_THEME.filter(({ link }) => link === category);

  return (
    <StyledContainer>
      {example_id && <StyledThumbnail src={img} alt='topImage' />}

      {hasSubject && <StyledSubject>{name}</StyledSubject>}
      <StyledPageTitle style={{ marginTop: !example_id ? '60px' : '0' }}>{pageTitle}</StyledPageTitle>
      {pageSubtitle && <StyledPageIntroduction dangerouslySetInnerHTML={{ __html: pageSubtitle }} />}

      {children}
    </StyledContainer>
  );
};

export default ExplainTemplate;

const StyledContainer = styled.main`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .exampleList {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 40px;
    padding: 50px 0;
    background-color: #f9f9f9;
  }
`;

const StyledSubject = styled.div`
  display: inline-block;
  margin-bottom: 5px;
  padding: 3px 10px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  background-color: #3cac40;
`;

const StyledThumbnail = styled.img`
  max-width: 1440px;
  max-height: 720px;
  width: 100%;
  height: 42vw;
  margin-bottom: 60px;
  object-fit: cover;

  @media screen and ${device.md} {
    margin-bottom: 30px;
  }
`;

const StyledPageTitle = styled.h1`
  width: 566px;
  margin-top: 10px;
  margin-bottom: 0;
  font-size: 32px;
  font-weight: 700;
  line-height: 40px;
  text-align: center;
  color: #14112a;

  @media screen and ${device.md} {
    width: 280px;
    font-size: 20px;
    line-height: 28px;
  }
`;

const StyledPageIntroduction = styled.p`
  width: 592px;
  margin-top: 10px;
  margin-bottom: 0px;
  font-size: 18px;
  text-align: center;

  @media screen and ${device.md} {
    width: 280px;
    font-size: 14px;
    line-height: 28px;
  }
`;
